import React from "react";
import { Row, Col } from "reactstrap";
import { AdminService } from "src/services/AdminService";
import { ProfileStat } from "src/models/ProfileStats";
import { DashboardGraph } from "./DashboardGraph";
import { DemoData } from "./GenerateDemo";
// involved implementation with tooltips https://codesandbox.io/s/flamboyant-roentgen-lp768?file=/src/components/CheckboxInput/style.ts

export const DashboardGraphs: React.FunctionComponent = () => {
  const [loading, setLoading] = React.useState(true);
  const [pageViews, setPageViews] = React.useState<ProfileStat[]>([]);
  const [contactEvents, setContactEvents] = React.useState<ProfileStat[]>([]);
  const [legend, setLegend] = React.useState<string[]>([]);
  const [message, setMessage] = React.useState("");
  const [demoGraph, setDemoGraph] = React.useState(false);
  React.useEffect(() => {
    // start three months ago
    const start = new Date();
    start.setMonth(start.getMonth() - 3);
    // end yesterday
    const end = new Date();
    end.setDate(end.getDate() - 1);
    AdminService.getStats(start.toISOString(), end.toISOString())
      .then((data) => {
        setPageViews(data.pageViews);
        setContactEvents([DemoData.generate(start, end, 5)]);
        setMessage('We had an issue loading email referral events.');
        setLegend(data.pageViews.map((pv) => pv.slug));
        return setLoading(false);
      })
      .catch((error) => {
        console.error(error);
        // if error code is 403, then show default graph with no data and tell the user they need to fill out their profile
        if (error && error.response && error.response.status === 403) {
          // forbidden because no published profiles, show message to user
          setMessage("Publish your profile to begin collecting analytics");
          setPageViews([DemoData.generate(start, end, 50)]);
          setContactEvents([DemoData.generate(start, end, 5)]);
          setDemoGraph(true);
          return setLoading(false);
        }
        setMessage("There was a problem loading your analytics, please try again");
        return setLoading(false);
      });
  }, []);
  return (
    <div>
      <Row className="mt-5">
        <Col xs="12">
          <h5 className="underline cta fw400">Profile Analytics</h5>
          <div className='help-text mt-1'>Analytic accuracy is affected by user cookie acceptance, actual tally may be higher.</div>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col xs="12" md="6" className="position-relative">
          <div className="fw400">Profile Views</div>
          <DashboardGraph
            labels={pageViews[0]?.rows.map((r) => {
              return r.week;
            })}
            series={pageViews.map((pv, i) => {
              return { className: `ct-series-${String.fromCharCode(97 + i)}`, data: pv.rows.map((r) => r.value) };
            })}
            loading={loading}
            demo={demoGraph}
          />
        </Col>
        <Col xs="12" md="6" className="position-relative">
          <div className="fw400">Email Referrals</div>
          <DashboardGraph
            labels={contactEvents[0]?.rows.map((r) => {
              return r.week;
            })}
            series={contactEvents.map((pv, i) => {
              return { className: `ct-series-${String.fromCharCode(97 + i)}`, data: pv.rows.map((r) => r.value) };
            })}
            loading={loading}
            demo={true}
          />
        </Col>
      </Row>
      <Row>
        <Col className="legend d-flex flex-row justify-content-around flex-wrap mt-2">
          {legend.map((l, i) => {
            return (
              <div key={i}>
                <div className={`ct-series-${String.fromCharCode(97 + i)}`}>&nbsp;</div>
                <span className="ms-2">{l}</span>
              </div>
            );
          })}
          <div className="sample-data">{message}</div>
        </Col>
      </Row>
    </div>
  );
};
